import { sharedRoutes } from "@shared/data/sharedRoutes";

export const graphqlFetch: typeof fetch = (
  uri: RequestInfo | URL,
  options?: RequestInit
): Promise<Response> => {
  if (
    typeof uri === "string" &&
    (uri.includes(sharedRoutes.external.wordpressGraphQL.production) ||
      uri.includes(sharedRoutes.external.wordpressGraphQL.staging))
  ) {
    return fetch(uri, options);
  }

  try {
    let operationName = "";
    if (typeof options?.body === "string") {
      operationName = JSON.parse(options.body).operationName;
    } else if (options?.body instanceof FormData) {
      const operations = options.body.get("operations");

      if (operations && typeof operations === "string") {
        operationName = JSON.parse(operations)?.operationName;
      }
    }

    return fetch(uri + "/GraphQL_" + operationName, options);
  } catch (e) {
    return fetch(uri, options);
  }
};
